/**
 * 定义菜单
 */
const menuList = [
  {
    name: "MAIN_MENU",
    title: "主菜单",
    fixed: true,
    children: [
      {
        name: "STATION_WORK",
        title: "吹膜工单",
        fixed: true,
      },
      {
        name: "MASS_PRODUCTION",
        title: "普通工单",
        fixed: true,
      },
      {
        name: "TRANSFER_DISPATCH",
        title: "待分配工单",
        fixed: true,
      },
      {
        name: "PPI_MANAGE",
        title: "制袋工序",
        fixed: true,
      },
      {
        name: "API_MANAGE",
        title: "印刷",
        fixed: true,
      },
      {
        name: "STATION_TEAMWORK",
        title: "压花抽边",
        fixed: true,
      },
      {
        name: "AGING_TEAMWORK",
        title: "膜卷分卷",
        fixed: true,
      },
      {
        name: "EDM_DOCUMENT",
        title: "覆膜工单",
        fixed: true,
      },
      {
        name: "PLM_DOCUMENT",
        title: "质检执行",
        fixed: true,
      },
      {
        name: "INSPECT_FIRST_ASSEMBLY_LINE",
        title: "订单查询",
        fixed: true,
      },
    ],
  },
];

export default menuList;
